import { Component, type ReactNode } from "react";
import { captureClientError } from "@/lib/sentry-client";

interface Props { children: ReactNode }
interface State { hasError: boolean }

/**
 * Error boundary global de React. Captura errores de render del cliente,
 * los reporta a Sentry (HTTP custom) y muestra un fallback recuperable.
 */
export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: { componentStack?: string }) {
    captureClientError(error, { source: "react_render", componentStack: info?.componentStack });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-background px-4">
          <div className="max-w-md text-center">
            <h1 className="text-2xl font-bold text-foreground">Algo salió mal</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Ocurrió un error inesperado. Ya quedó registrado. Probá recargar la página.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-6 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
            >
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
